import { render, staticRenderFns } from "./MyCover.vue?vue&type=template&id=124499a6&"
import script from "./MyCover.vue?vue&type=script&lang=js&"
export * from "./MyCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124499a6')) {
      api.createRecord('124499a6', component.options)
    } else {
      api.reload('124499a6', component.options)
    }
    module.hot.accept("./MyCover.vue?vue&type=template&id=124499a6&", function () {
      api.rerender('124499a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/MyCover/Summaries/Tabs/MyCover.vue"
export default component.exports